import React from 'react'
import { tv } from 'tailwind-variants'

// An empty state, in the manner of shadcn/ui's Empty: an icon on a muted tile, a title, a line saying
// what's missing and why, then what can be done about it. Sized for a section of a panel or menu (Edit column's
// Options); a page's larger size can be added as a variant when a page needs one.
const empty = tv({
  slots: {
    root: 'flex min-w-0 flex-col items-center justify-center gap-4 rounded-lg border border-dashed border-divider px-4 py-5 text-center text-balance',
    header: 'flex max-w-sm flex-col items-center gap-1.5 text-center',
    media:
      'mb-1 flex size-8 shrink-0 items-center justify-center rounded-lg bg-surface-sunken text-body [&_svg]:size-4 [&_svg]:shrink-0',
    title: 'text-[14px] leading-5 font-medium tracking-tight text-body',
    description: 'text-[13px] leading-5 text-muted',
    content: 'flex w-full max-w-sm min-w-0 flex-col items-center gap-2 text-[13px] text-balance'
  }
})

interface EmptyProps {
  icon?: React.ReactNode
  title: string
  /** What's missing, and why it matters, in a sentence. */
  description?: React.ReactNode
  /** What can be done about it: a button, or a button and a quieter way out. */
  children?: React.ReactNode
  className?: string
  'data-testid'?: string
}

const Empty: React.FC<EmptyProps> = ({ icon, title, description, children, className, ...data }) => {
  const styles = empty()
  return (
    <div className={styles.root({ class: className })} {...data}>
      <div className={styles.header()}>
        {icon && <div className={styles.media()}>{icon}</div>}
        <div className={styles.title()}>{title}</div>
        {description && <div className={styles.description()}>{description}</div>}
      </div>
      {children && <div className={styles.content()}>{children}</div>}
    </div>
  )
}

export default Empty
